/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Recording_Show_IndicatorInputs */

const en_forms_teams_settings_recording_show_indicator = /** @type {(inputs: Forms_Teams_Settings_Recording_Show_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Indicator`)
};

const de_forms_teams_settings_recording_show_indicator = /** @type {(inputs: Forms_Teams_Settings_Recording_Show_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufzeichnungs-Indikator anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Indicator" |
*
* @param {Forms_Teams_Settings_Recording_Show_IndicatorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_recording_show_indicator = /** @type {((inputs?: Forms_Teams_Settings_Recording_Show_IndicatorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Recording_Show_IndicatorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_recording_show_indicator(inputs)
	return de_forms_teams_settings_recording_show_indicator(inputs)
});